import { NessieThemeColors } from "@classdojo/web/nessie/components/theme";
import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import React from "react";

type Size = "small" | "medium" | "large";

const Tag: React.FC<{
  size?: Size;
  color: NessieThemeColors;
  children: React.ReactNode;
}> = ({ size, color, children }) => {
  const style: ThemeUIStyleObject = {
    ...baseStyle,
    ...sizeOverrides[size || "small"],
    color,
    borderColor: color,
  };
  return <div sx={style}>{children}</div>;
};

export default Tag;

const baseStyle: ThemeUIStyleObject = {
  display: "inline-block",
  whiteSpace: "nowrap",
  fontWeight: 600,
  margin: RAW_cssValue("4px"),
  backgroundColor: "dt_background_primary",
  borderStyle: "solid",
  lineHeight: "1.2",
};

const sizeOverrides: { [size: string]: ThemeUIStyleObject } = {
  small: {
    fontSize: "14px",
    borderRadius: "dt_radius_s",
    borderWidth: "1px",
    padding: RAW_cssValue("4px 8px"),
  },
  medium: {
    fontSize: "16px",
    borderRadius: "dt_radius_s",
    borderWidth: "1.5px",
    padding: RAW_cssValue("6px 12px"),
  },
  large: {
    fontSize: "32px",
    borderRadius: "dt_radius_s",
    borderWidth: "3px",
    padding: RAW_cssValue("12px 24px"),
  },
};
